import { createClient } from 'urql';
var API_URL = 'https://api.lens.dev';
export var client = createClient({
    url: API_URL
});
//# sourceMappingURL=client.js.map